import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CORE_VALUES, PHILOSOPHY } from '../content';
import { RevealDirective } from '../reveal.directive';

@Component({
  selector: 'app-story',
  imports: [RevealDirective],
  templateUrl: './story.html',
  styleUrl: './story.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Story {
  protected readonly philosophy = PHILOSOPHY;
  protected readonly values = CORE_VALUES;
}
